const truncateText = (str, chars, strEnd = '...') => str.length > chars ? str.substring(0, chars) + strEnd : str;
module.exports = truncateText;